import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class WorkbookStore extends EventEmitter {
	constructor() {
		super();

		this.workbookData = {
			auditLevels: [],
			metaData: [],
			selectedActivationData: [],
			availableActivations: [],
			placementAPIConfigStatus: null,
			jiraStatus: null,
			enabledColumns: [],
			trafficManagerEnabled: false
		};

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchAuditLevelConfig:
					this.workbookData.auditLevels = action.value;
					this.emit("audit_levels");
					break;
				case AppActionConstants.fetchWorkbookActivationCampaigns:
					this.workbookData.availableActivations =
						action?.value?.AvailableActivations?.map(({ OptionLabel, OptionID }) => ({ label: OptionLabel, value: OptionID })) || [];
					this.workbookData.selectedActivationData = action.value.SelectedActivationMetaData;
					this.workbookData.isTrafficEnabled = action.value.IsTrafficEnabled;
					this.workbookData.templateExists = action.value.TemplateExists;
					this.workbookData.campaignJiraTicketLink = action.value.SelectedActivationMetaData.CampaignJiraTicketLink;
					this.workbookData.trafficManagerEnabled = action.value.SelectedActivationMetaData.IsTrafficManagerEnabled;
					this.emit("updated_metaData");
					break;
				case AppActionConstants.placementAPIConfigFetched:
					this.workbookData.placementAPIConfigStatus = action.value.SyncStatus;
					this.workbookData.jiraStatus = action.value.JIRAStatus;
					break;
				case AppActionConstants.getEnabledColumns:
					this.workbookData.enabledColumns = action.value;
					this.emit("enabled_columns_fetched");
					break;
				case AppActionConstants.setEnabledColumns:
					const existingValue = this.workbookData.enabledColumns?.find(
						({ ApplicationUserSettingsID }) => ApplicationUserSettingsID == action.value.ApplicationUserSettingsID
					);
					if (!existingValue) {
						if (this.workbookData.enabledColumns instanceof Array) {
							this.workbookData.enabledColumns = [
								...this.workbookData.enabledColumns,
								{
									ApplicationUserSettingsID: action.value?.ApplicationUserSettingsID,
									CampaignID: action.value?.CampaignID,
									HierarchyLevelID: action.value?.HierarchyLevelID,
									Preferences: action.value?.ColumnHeaders ? JSON.stringify(action?.value?.ColumnHeaders) : ""
								}
							];
						}
						this.emit("enabled_columns_fetched");
					}
					break;
				case AppActionConstants.trafficManagerToggled:
					this.workbookData.trafficManagerEnabled = action.value;
					this.emit("traffic_manager_toggled");
					break;
				default:
					break;
			}
		});
	}

	getAuditLevels = () => this.workbookData.auditLevels;
	getMetaData = () => this.workbookData.selectedActivationData;
	getAvailableActivations = () => this.workbookData.availableActivations;
	getPlacementAPIConfigStatus = () => this.workbookData.placementAPIConfigStatus;
	getJIRAStatus = () => this.workbookData.jiraStatus;
	getIsTrafficEnabled = () => this.workbookData.isTrafficEnabled;
	getTemplateExists = () => this.workbookData.templateExists;
	getEnabledColumns = () => this.workbookData.enabledColumns;
	getTrafficManagerEnabled = () => this.workbookData.trafficManagerEnabled;
	getCampaignJiraTicketLink = () => this.workbookData.campaignJiraTicketLink;
}

export default new WorkbookStore();
